// extracted by mini-css-extract-plugin
module.exports = {"paneBackground":"SidePane_paneBackground__WsosZ","paneHeader":"SidePane_paneHeader__AbPXH","paneContent":"SidePane_paneContent__5s5e7"};